import React from "react";
import { MdLocationOn, MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";
import { GiRotaryPhone, GiSmartphone } from "react-icons/gi";
import Logo from "./assets/images/Logo/Hazar-terra-leaf-w.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();



  return (
    <footer id="contact" className="bg-gradient-to-r from-[#9ec083] to-[#69B578] text-white py-8">
      <div className="container mx-auto px-4 text-center md:text-left w-full">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo Section */}
          <div className="mb-4 md:mb-0 md:w-1/3 flex flex-col items-center md:items-start">
            <img
              src={Logo}
              alt="Logo"
              className="w-32 h-auto mb-4"
            />
            <p className="text-sm text-center md:text-left">
              Des produits frais, cultivés localement, livrés aux tables du
              monde entier.
            </p>
          </div>

          {/* Sitemap Section */}
          <div className="text-sm pl-0 md:pl-20 my-4 md:mt-0 md:mb-0 md:w-1/3 flex flex-col items-center md:items-start">
            <h3 className="text-lg mb-2 underline">Plan du site</h3>
            <ul className="space-y-2 text-center md:text-left">
              <li>
                <a href="#home" className="hover:underline">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="hover:underline">
                  À propos
                </a>
              </li>
              <li>
                <a href="#products" className="hover:underline">
                  Produits
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:underline">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information Section */}
          <div className="text-sm my-4 md:mt-0 md:mb-0 md:w-1/3 flex flex-col items-center md:items-start">
            <h3 className="text-lg mb-2 underline">Contact</h3>
            <ul className="space-y-2 text-center md:text-left">
              <li className="flex items-center justify-center md:justify-start">
                <MdLocationOn className="mr-2 hidden md:block" />
                298 Boulevard Mohamed V, Casablanca - Maroc
              </li>
              <div className="flex space-x-3">
              <div className="space-y-1">
              <li className="flex items-center justify-center md:justify-start">
                <FaWhatsapp className="mr-2" />
                <button className="hover:underline">
                +212 7 69 05 52 35
                </button>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <FaWhatsapp className="mr-2" />
                <button className="hover:underline">
                +212 6 62 11 77 83
                </button>
              </li>
              </div>
              <div className="className=space-y-1">
              <li className="flex items-center justify-center md:justify-start">
                <GiSmartphone className="mr-2" />
                <button className="hover:underline">
                +212 6 61 07 56 44
                </button>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <GiSmartphone className="mr-2" />
                <button className="hover:underline">
                +212 6 61 09 34 28
                </button>
              </li>
              </div>
              </div>
              <li className="flex items-center justify-center md:justify-start">
                <GiRotaryPhone className="mr-2" />
                <button className="hover:underline">
                +212 5 22 44 46 18
                </button>
              </li>
              <li className="flex items-center justify-center md:justify-start">
                <MdEmail className="mr-2" />
                contact@hazar-terra.ma
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 border-t border-white pt-4 text-center text-xs">
          <p>&copy; {currentYear} Tous droits réservés.</p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;